// 物件選択
const SelectProperty = {
  namespaced: true,

  state: {
    property: [],
  },
  getters: {
    getProperty: state => {
      return state.property
    },
  },
  mutations: {
    setProperty(state, property) {
      state.property = property
    },
  },
  actions: {
    reset({ commit }) {
      commit('setProperty', [])
    },
  },
}

export default SelectProperty
